import React from "react";
import "./App.css";
import { CustomRoutes } from "components/route/CustomRoutes";
function App() {
  return <CustomRoutes />;
}

export default App;
